import { createContext, useContext, useMemo, useState } from 'react';

export const RANGES = [
  { value: 'today', label: 'Today' },
  { value: '7d', label: 'Last 7 Days' },
  { value: '30d', label: 'Last 30 Days' },
];

// "live" = normal mock success. The others force a UI state for verification.
export const SCENARIOS = [
  { value: 'live', label: 'Success' },
  { value: 'loading', label: 'Loading' },
  { value: 'empty', label: 'Empty' },
  { value: 'error', label: 'Error' },
];

const DashboardContext = createContext(null);

export function DashboardProvider({ children }) {
  const fromUrl = new URLSearchParams(window.location.search).get('state');
  const [range, setRange] = useState('today');
  const [scenario, setScenario] = useState(
    SCENARIOS.some((s) => s.value === fromUrl) ? fromUrl : 'live'
  );
  const value = useMemo(() => ({ range, setRange, scenario, setScenario }), [range, scenario]);
  return <DashboardContext.Provider value={value}>{children}</DashboardContext.Provider>;
}

export function useDashboard() {
  const ctx = useContext(DashboardContext);
  if (!ctx) throw new Error('useDashboard must be used inside <DashboardProvider>');
  return ctx;
}
